
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Luxurycabserviceinpuneforcorporate() {



const cardData =
{
  keyword: 'Luxury Cab Service in Pune for Corporate',
  heading: 'eTravo: Luxury Cab Service in Pune for Corporate Travel',
  headingDescription: 'eTravo offers premium chauffeur-driven luxury cab services for corporate travel in Pune. Whether it’s an executive meeting, a high-profile event, or daily VIP commutes, our luxury vehicles—including sedans, Innovas, and premium SUVs—are equipped for comfort, style, and reliability. We cater to board members, CXOs, visiting clients, and senior professionals who require impeccable service and smooth travel. With trained drivers, climate-controlled cabins, and on-time pickups, eTravo ensures your business travel in Pune is seamless, stylish, and efficient.',

  top: 'Top Places in Pune Frequently Visited with Luxury Corporate Cabs',
  topPlaces: [
    {
      title: 'JW Marriott Hotel Pune',
      description: 'This 5-star hotel on Senapati Bapat Road is a go-to destination for boardroom meetings, CEO summits, and global client visits. eTravo’s luxury cabs regularly handle executive pick-ups and drop-offs here, ensuring elite treatment and timely arrival.'
    },
    {
      title: 'The Ritz-Carlton Pune',
      description: 'A favorite for international business delegates and top-level client hosting. Our chauffeur-driven luxury cabs provide a flawless travel experience to and from this prestigious Koregaon Park address.'
    },
    {
      title: 'The Westin Pune Koregaon Park',
      description: 'Located near major business districts and known for hosting corporate conferences and client dinners. eTravo provides comfortable and elegant cabs for senior leadership attending high-profile gatherings here.'
    },
    {
      title: 'Pune International Airport (Lohegaon)',
      description: 'For VIP airport pickups and drop-offs, our luxury fleet is frequently used by companies to receive clients, partners, and global executives. Our drivers greet passengers at arrival with name boards and ensure a premium experience.'
    },
    {
      title: 'Hyatt Regency Pune',
      description: 'Commonly chosen by corporates for MICE (Meetings, Incentives, Conferences, and Exhibitions). eTravo offers polished, well-dressed chauffeur services and premium cars for all business occasions hosted here.'
    },
    {
      title: 'Koregaon Park Business Lounges',
      description: 'This upscale area hosts many boutique offices, co-working spaces, and foreign consulates. eTravo’s luxury cabs are regularly booked for executive meetings, embassy visits, and business lunches around this area.'
    },
    {
      title: 'MCCIA Trade Tower',
      description: 'A major commercial hub where business deals and conferences take place. Our luxury cab service ensures that decision-makers and stakeholders arrive on time and in total comfort.'
    },
    {
      title: 'Baner-Balewadi Business District',
      description: 'A fast-growing premium business zone with modern office towers and networking clubs. eTravo’s stylish cabs are ideal for transporting executives to client meetings or high-end team events in this vibrant part of Pune.'
    },
    {
      title: 'Residency Club',
      description: 'This elite club in Bund Garden often hosts business lunches, private client meetings, and deal closures. Our premium cab services are a perfect match for the venue’s sophisticated clientele.'
    },
    {
      title: 'Aga Khan Palace',
      description: 'Chosen occasionally by corporate guests and diplomats for cultural retreats or heritage-based offsite discussions. eTravo ensures classy and smooth rides to this landmark from anywhere in Pune.'
    }
  ],

  services: [
    {
      name: 'Executive Luxury Cab Hire Pune',
      description: 'Tailored for CXOs, board members, and senior guests, our executive luxury cab services feature plush interiors, silent cabins, bottled water, and courteous chauffeurs. Vehicles include premium sedans, SUVs, and Innovas with business-class interiors.'
    },
    {
      name: 'Premium Corporate Cab Services Pune',
      description: 'From exclusive airport pickups to all-day availability for business events, our premium cab services cater to organizations looking for reliability, brand image, and a refined travel experience for their team and guests.'
    },
    {
      name: 'AC Luxury Cabs for Business Pune',
      description: 'Every cab in our fleet is fully air-conditioned with temperature control, ambient lighting, and pushback seating. Ideal for longer rides to client meetings or conferences without compromising on comfort.'
    },
    {
      name: 'Comfortable Corporate Travel by Cab Pune',
      description: 'Our cab services go beyond just pick and drop. We provide stress-free, ergonomic, and peaceful rides that allow senior professionals to relax, take calls, or work en route to the office or meeting venue.'
    },
    {
      name: 'Business-Class Cab Service Pune',
      description: 'Just like flying business class, our cabs are designed to provide quiet, spacious, and feature-rich travel that impresses clients and satisfies executives. We focus on creating a dignified and professional journey.'
    },
    {
      name: 'Luxury Airport Cab Pune',
      description: 'Our airport service offers real-time flight tracking, meet-and-greet signage, and well-groomed chauffeurs—ensuring that your corporate guests arrive and depart from Pune Airport with style and punctuality.'
    },
    {
      name: 'Corporate Client Transport Pune',
      description: 'Make a great first impression by picking up your clients in one of our premium vehicles. Our cab interiors are neat, fragrance-controlled, and stocked with essentials, reflecting the high standards of your business.'
    },
    {
      name: 'Monthly Luxury Cab Rentals Pune',
      description: 'For companies that require frequent luxury travel, we offer monthly rental packages at competitive corporate rates. Enjoy uninterrupted cab availability for your top executives with priority scheduling.'
    },
    {
      name: 'Reliable Luxury Cab Pune',
      description: 'We are known for our commitment to time, clean vehicles, polite drivers, and round-the-clock support. Our luxury fleet is regularly maintained and always ready for business trips of any scale.'
    },
    {
      name: 'VIP Corporate Cab Service Pune',
      description: 'Whether it’s an international guest, keynote speaker, or visiting stakeholder, our VIP cab service includes everything from red carpet handling to secure travel, enhancing the entire corporate experience.'
    },
    {
      name: 'Luxury Cab for Business Meetings Pune',
      description: 'Need to attend or host multiple meetings across the city? Our chauffeurs stay on standby, plan optimized routes, and ensure quick inter-location travel in total luxury.'
    },
    {
      name: 'Luxury Staff Commute Cab Pune',
      description: 'For your top-tier employees, we offer daily pick-up and drop-off cab services using executive vehicles with high safety ratings, corporate decorum, and maximum comfort during rush hours.'
    },
    {
      name: 'AC Premium Cab Service Pune',
      description: 'Every ride includes spotless interiors, climate control, smooth suspension, and a driver who’s trained in business etiquette. Our premium cab service offers unmatched travel for important workdays.'
    },
    {
      name: 'Corporate Event Luxury Cab Pune',
      description: 'Hosting a corporate event or business conference? We offer luxury fleet arrangements for group movements, speaker logistics, and VIP transport, tailored to fit your event flow and timings.'
    },
    {
      name: 'Chauffeur-Driven Luxury Cab Pune',
      description: 'Our chauffeurs are not just drivers—they’re trained professionals in formal dressing, route knowledge, and client handling. Each chauffeur is handpicked to represent your business with respect and reliability.'
    }
  ],

  tableData: [
    ['Executive Luxury Cab Hire Pune', 'Premium Corporate Cab Services Pune'],
    ['AC Luxury Cabs for Business Pune', 'Comfortable Corporate Travel by Cab Pune'],
    ['Business-Class Cab Service Pune', 'Luxury Airport Cab Pune'],
    ['Corporate Client Transport Pune', 'Monthly Luxury Cab Rentals Pune'],
    ['Reliable Luxury Cab Pune', 'VIP Corporate Cab Service Pune'],
    ['Luxury Cab for Business Meetings Pune', 'Luxury Staff Commute Cab Pune'],
    ['AC Premium Cab Service Pune', 'Corporate Event Luxury Cab Pune'],
    ['Chauffeur-Driven Luxury Cab Pune', '']
  ],





"whychoose": [
    {
        "WhyChooseheading": "Premium Fleet for Executive-Level Comfort",
        "WhyChoosedescription": "eTravo offers a range of luxury cabs including Honda City, Toyota Camry, Skoda Superb, Innova Crysta, and more, ideal for CEOs, clients, and business heads traveling within or around Pune."
    },
    {
        "WhyChooseheading": "Perfect for Business Meetings, Conferences, and VIP Guests",
        "WhyChoosedescription": "Our luxury cab services are tailored for corporate events, high-stakes meetings, and top-level guest transport. Impress your stakeholders with seamless, chauffeured travel experiences."
    },
    {
        "WhyChooseheading": "Professional Chauffeurs with Corporate Etiquette",
        "WhyChoosedescription": "All drivers are trained in professional conduct, punctuality, and discretion—ensuring your executives and clients receive respectful, first-class treatment."
    },
    {
        "WhyChooseheading": "Hourly, Daily, and Multi-Day Booking Flexibility",
        "WhyChoosedescription": "Whether it’s a single airport transfer or multiple-day travel for board members, our flexible packages make it easy to schedule premium transport based on your event needs."
    },
    {
        "WhyChooseheading": "Real-Time Tracking with On-Demand Support",
        "WhyChoosedescription": "Track luxury cabs live, receive ETA alerts, and make last-minute adjustments through our central dashboard or with help from a dedicated account manager."
    },
    {
        "WhyChooseheading": "Elegant Interiors and Advanced Amenities",
        "WhyChoosedescription": "Our luxury cabs are equipped with leather seats, air purifiers, rear AC vents, ambient lighting, and bottled water—delivering an unmatched experience on the road."
    },
    {
        "WhyChooseheading": "Sanitized and Safe Travel Always",
        "WhyChoosedescription": "Each luxury cab undergoes strict sanitization before every ride. Vehicles are equipped with first aid kits, safety belts, and follow all transport compliance standards."
    },
    {
        "WhyChooseheading": "GST-Compliant Billing and Corporate Invoicing",
        "WhyChoosedescription": "We offer digital invoicing, GST support, and monthly billing cycles tailored to your organization’s accounting needs—ensuring hassle-free expense tracking."
    }
]
}


const faqData = [
    [
        {
            question: 'What vehicles are included in eTravo’s luxury cab fleet?',
            answer: 'Our fleet includes premium models like Honda City, Skoda Superb, Toyota Innova Crysta, and other executive-level sedans and SUVs designed for corporate travel.'
        },
        {
            question: 'Can luxury cabs be booked for specific events or guests?',
            answer: 'Yes, we provide cab services specifically for board meetings, executive transfers, conferences, and VIP guest movement with advance scheduling options.'
        },
        {
            question: 'Are the drivers trained in corporate hospitality?',
            answer: 'Absolutely. Our chauffeurs are professionally trained in etiquette, communication, punctuality, and maintaining confidentiality.'
        },
        {
            question: 'Is real-time cab tracking available during rides?',
            answer: 'Yes, all luxury vehicles are GPS-enabled, allowing real-time location tracking, route monitoring, and status updates for admin teams or hosts.'
        },
        {
            question: 'Do you provide half-day or full-day luxury cab rental?',
            answer: 'Yes, eTravo offers flexible packages—hourly, half-day, full-day, and multi-day plans—to suit different corporate schedules and requirements.'
        },
        {
            question: 'Is monthly billing and GST invoicing available for companies?',
            answer: 'Yes, we offer itemized monthly billing with GST-compliant invoices for easy expense claims, audits, and vendor payments.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Ajay Mehta',
        designation: 'Corporate Liaison, BrightBridge Finance',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s luxury cab service is our go-to option for executive client pickups. Their vehicles are spotless and the drivers are always well-presented and on time.”'
    },
    {
        name: 'Ms. Devika Karmarkar',
        designation: 'Admin Lead, CrestEdge Consulting',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked luxury cabs for our leadership summit. Every ride was smooth, comfortable, and perfectly scheduled. Excellent service for corporate clients.”'
    }
];
















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Cab Service in Pune for Corporate",
  "image": "https://www.etravo.in/images/keyword/luxury-cab-service-corporate-pune.jpg",
  "description": "Book luxury cab service in Pune for corporate travel with eTravo. Ideal for executive transport, VIP client meetings, staff commutes, and airport transfers. Choose from chauffeur-driven premium cabs with AC, professional drivers, and flexible packages.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8516"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/luxury-cab-service-corporate-pune"
  }
};




    return (
        <div>


<Helmet>
  <title>Luxury Cab Service in Pune for Corporate | Executive & VIP Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire luxury AC cabs for corporate travel, client meetings, airport transfers, and staff commutes in Pune. eTravo offers chauffeur-driven, premium cab services for business needs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxurycabserviceinpuneforcorporate;